import http from './../http.interceptor.js';


export function pustRegister(params) {
	let pixelClick = {};
	pixelClick.gj = window.localStorage.getItem('pixel_gj') || window.document.documentElement.getAttribute('data-pixel_gj');
	pixelClick.oks = window.localStorage.getItem('pixel_oks') || window.document.documentElement.getAttribute('data-pixel_oks');
	pixelClick.bigo = window.localStorage.getItem('pixel_bigo') || window.document.documentElement.getAttribute('data-pixel_bigo');
	pixelClick.kwai = window.localStorage.getItem('pixel_kwai') || window.document.documentElement.getAttribute('data-pixel_kwai');
	pixelClick.fb = window.localStorage.getItem('pixel_fb') || window.document.documentElement.getAttribute('data-pixel_fb');
	return http.post('/v3.login/register', { pixel_click: pixelClick, ...params })
}

export function login(params) {
	return http.post('/v3.login/login', params)
}

export function withdrawPassword(params) {
	return http.post('/v3.user/withdrawPassword', params)
}
export function changeLoginPassword(params) {
	return http.post('/v3.user/changeLoginPassword', params)
}


export function payments(params) {
	return http.post('/v3.home/payments', {
		isLOgin: true,
		...params
	})
}



export function recharge(params) {
	return http.post('/v3.pay/recharge', params)
}
export function rechargeRecords(params) {
	return http.post('/v3.pay/rechargeRecords', {
		isLOgin: true,
		...params
	})
}

export function getBank(params) {
	return http.post('/v3.user/getBank', params)
}
export function setBank(params) {
	return http.post('/v3.user/setBank', params)
}

export function withdraw(params) {
	return http.post('/v3.pay/withdraw', params)
}
export function getBetTasks(params) {
	return http.post('/v3.user/getBetTasks', params)
}
export function withdrawRecords(params) {
	return http.post('/v3.pay/withdrawRecords', params)
}







